<nav class="main-menu">
  <ul class="Userprofile">
    <li class="userBg">
      <div class="userMargin">
        <div class="row">
        <div class="col-12">
          <img class="userPic" src="./assets/img/user.png">
          <strong class="userPic">
            <span> {{username}}({{Role}})
            </span>
          </strong>
        </div>
        </div>
      </div>
    </li>
  </ul>
  <div id="mySidenav">
    <!-- <a routerLink="/worker/ammendment"><i class="fa fa-address-card text-info" aria-hidden="true"></i><span class="nav-text">New Worker Ammendment</span></a> -->

    <ul class="main" *ngIf="userinfo.ELRole !='PSLD' && (userinfo.ELRole !='AUDT' || userinfo.role!='1040')">
      <div *ngIf=" userinfo.role!='sewakendra'">

        <li class="has-subnav mt-2"
          *ngIf="userinfo.role=='1022' || userinfo.role=='1023' || userinfo.role=='1017' ||  userinfo.role ==1001 || userinfo.role=='sewakendra'">


          <!-- <a href="https://bocw.punjab.gov.in/bapi/reg/provisional/worker" trarget="_blank" class="text-danger">New Worker Registration Provisional </a> -->
          <a routerLink="/worker/register"><i class="fa fa-address-card text-info" aria-hidden="true"></i><span
              class="nav-text">New Worker Registration</span></a>

        </li>
        <li class="has-subnav mt-2"
        *ngIf="userinfo.role ==1001">


        <!-- <a href="https://bocw.punjab.gov.in/bapi/reg/provisional/worker" trarget="_blank" class="text-danger">New Worker Registration Provisional </a> -->
        <a routerLink="/worker/oldregno"><i class="fa fa-address-card text-info" aria-hidden="true"></i><span
            class="nav-text">Old Registration No.</span></a>

      </li>
        <li class="has-subnav mt-4" *ngIf="userinfo.role=='VLE' || userinfo.role=='1001'">
          <a routerLink="/worker/scheme-view-forms" [queryParams]="{id: '60'}"><i class="fa fa-plus-square text-success" aria-hidden="true"></i><span class="nav-text">Apply Cycle Scheme</span></a>
        </li>
        
 
        <!-- <li class="has-subnav mt-2"  *ngIf="userinfo.role=='1017' || userinfo.role !=1006 && userinfo.role !='LBCR' && userinfo.role ==1001  && userinfo.role !=1005 && userinfo.role !=1009 && userinfo.role !=1010 && userinfo.role !=1008 && userinfo.role!='sewakendra' && userinfo.ELRole!='PSLD'" >


       <a routerLink="/worker/ammendment"><i class="fa fa-address-card text-info" aria-hidden="true"></i><span class="nav-text">New Worker Ammendment</span></a>
     </li>
    <li class="has-subnav mt-4" *ngIf="userinfo.role=='1022'   || userinfo.role=='1023'   || userinfo.role=='1001'   || userinfo.role=='sewakendra'">
          <a routerLink="/worker/cycle-scheme-forms"><i class="fa fa-plus-square text-success" aria-hidden="true"></i><span class="nav-text">Apply Cycle Scheme</span></a>
        </li>
 

       <li class="has-subnav mt-2"  *ngIf="userinfo.role !='1006' && userinfo.ELRole !='LBCR' || userinfo.role == 1001 ||  userinfo.role == 1009"  >
          <a routerLink="/inspector/batch-dhl"><i class="fa fa-credit-card fa-2x text-info"></i><span class="nav-text">DHL upload Excel</span></a>
        </li>
        <li class="has-subnav mt-2"  *ngIf="userinfo.role !='1006' && userinfo.ELRole !='LBCR' || userinfo.role == 1001 ||  userinfo.role == 1017 ||  userinfo.role == 1004"  >
          <a routerLink="/inspector/batch-excel"><i class="fa fa-credit-card fa-2x text-info"></i><span class="nav-text">ALC upload Excel</span></a>
        </li>
        <li class="has-subnav mt-2"  *ngIf="userinfo.role !='1006' && userinfo.ELRole !='LBCR' || userinfo.role == 1001 ||  userinfo.role == 1017 ||  userinfo.role == 1004"  >
          <a routerLink="/inspector/dhl-excel"><i class="fa fa-credit-card fa-2x text-info"></i><span class="nav-text">DHL Excel</span></a>
        </li> 
        <li class="has-subnav mt-2"  *ngIf="userinfo.role=='1001'"  >
          <a routerLink="/inspector/viewoldportal"><i class="fa fa-credit-card fa-2x text-info"></i><span class="nav-text">viewoldportal</span></a>
        </li>
        <li class="has-subnav mt-2"  *ngIf="userinfo.role == 1001 "  >
          <a routerLink="/inspector/oldportal-payment"><i class="fa fa-credit-card fa-2x text-info"></i><span class="nav-text">oldportal-payment</span></a>
        </li>-->



        <!----hhhhhhhhhhhhhhhhhhhhhhhhhhh-->

        <li class="has-subnav mt-4" *ngIf="userinfo.role=='1004'">
          <a routerLink="/inspector/special-exgratia-schemes"><i class="fa fa-plus-square text-success"
              aria-hidden="true"></i><span class="nav-text">Dashboard Special Exgratia Schemes</span></a>
        </li>

        <li class="has-subnav mt-4" *ngIf="userinfo.role=='1004'">
          <a (click)="goschemeforms()"><i class="fa fa-plus-square text-success" aria-hidden="true"></i><span
              class="nav-text">Apply Exgratia Schemes(Special)</span></a>
        </li>
        <li class="has-subnav mt-4" *ngIf="userinfo.role=='1006'">
          <a routerLink="/inspector/exgratia-special-schemes"><i class="fa fa-plus-square text-success"
              aria-hidden="true"></i><span class="nav-text"> EXgratia Special Schemes</span></a>
        </li>
        <!-- <li class="has-subnav mt-4" *ngIf="userinfo.role=='1022'   || userinfo.role=='1023'   || userinfo.role=='1001'   || userinfo.role=='sewakendra'">
          <a routerLink="/worker/cycle-scheme-forms"><i class="fa fa-plus-square text-success" aria-hidden="true"></i><span class="nav-text">Apply Cycle Scheme</span></a>
        </li> 
 

       <li class="has-subnav mt-2"  *ngIf="userinfo.role !='1006' && userinfo.ELRole !='LBCR' || userinfo.role == 1001 ||  userinfo.role == 1009"  >
          <a routerLink="/inspector/batch-dhl"><i class="fa fa-credit-card fa-2x text-info"></i><span class="nav-text">DHL upload Excel</span></a>
        </li>
        <li class="has-subnav mt-2"  *ngIf="userinfo.role !='1006' && userinfo.ELRole !='LBCR' || userinfo.role == 1001 ||  userinfo.role == 1017 ||  userinfo.role == 1004"  >
          <a routerLink="/inspector/batch-excel"><i class="fa fa-credit-card fa-2x text-info"></i><span class="nav-text">ALC upload Excel</span></a>
        </li>
        <li class="has-subnav mt-2"  *ngIf="userinfo.role !='1006' && userinfo.ELRole !='LBCR' || userinfo.role == 1001 ||  userinfo.role == 1017 ||  userinfo.role == 1004"  >
          <a routerLink="/inspector/dhl-excel"><i class="fa fa-credit-card fa-2x text-info"></i><span class="nav-text">DHL Excel</span></a>
        </li> 
        <li class="has-subnav mt-2"  *ngIf="userinfo.role=='1001'"  >
          <a routerLink="/inspector/viewoldportal"><i class="fa fa-credit-card fa-2x text-info"></i><span class="nav-text">viewoldportal</span></a>
        </li>
        <li class="has-subnav mt-2"  *ngIf="userinfo.role == 1001 "  >
          <a routerLink="/inspector/oldportal-payment"><i class="fa fa-credit-card fa-2x text-info"></i><span class="nav-text">oldportal-payment</span></a>
        </li>
        
        <li class="has-subnav mt-4" *ngIf="userinfo.role=='1022'   || userinfo.role=='1023'   || userinfo.role=='1001'   || userinfo.role=='sewakendra'">
          <a (click)="goschemeforms()"><i class="fa fa-plus-square text-success" aria-hidden="true"></i><span class="nav-text">Apply EXgratia Special Schemes</span></a>
        </li>
 <li class="has-subnav mt-4" *ngIf="userinfo.role=='1006'">
          <a routerLink="/inspector/exgratia-special-schemes"><i class="fa fa-plus-square text-success" aria-hidden="true"></i><span class="nav-text"> EXgratia Special Schemes</span></a>
        </li> -->
        <!-- hereeeeeeeeeeeeee -->
        <li class="has-subnav mt-4"
          *ngIf="userinfo.role=='1022'   || userinfo.role=='1023'   || userinfo.role=='1001'   || userinfo.role=='sewakendra'">
          <a routerLink="/inspector/scheme-index"><i class="fa fa-plus-square text-success" aria-hidden="true"></i><span
              class="nav-text">Apply Welfare Schemes</span></a>
        </li>


        <li class="has-subnav mt-2"
          *ngIf="userinfo.role=='1041' || userinfo.ELRole =='BCAO'  || userinfo.role=='1017' || userinfo.ELRole =='LBIN'  || userinfo.role=='1004' || userinfo.role=='1001' || userinfo.role =='1006' || userinfo.ELRole =='LBCR'">
          <a routerLink="/inspector/dashboard"><i style="color: #89C7F3" class="fa fa-dashboard fa-2x"></i><span
              class="nav-text">Registered of worker applications</span></a>
        </li>
        <li class="has-subnav mt-2" *ngIf="userinfo.role == '1041' && userinfo.role !='VLE' && userinfo.ELRole !='ALLC' && userinfo.role !='1005' ">
          <a routerLink="/inspector/dgr-objections-schemes"><i style="color: #89C7F3"
              class="fa fa-dashboard fa-2x"></i><span class="nav-text">Dashboard of Schemes </span></a>
        </li>
        <li class="has-subnav mt-2" *ngIf="userinfo.ELRole =='LBIN'  || userinfo.role=='1004' || userinfo.role=='1001'">
          <a routerLink="/inspector/deregister"><i style="color: #89C7F3" class="fa fa-dashboard fa-2x"></i><span
              class="nav-text">DeRegister of worker applications</span></a>
        </li>


        <li class="has-subnav mt-2"
        *ngIf="userinfo.ELRole =='ALLC'  || userinfo.role=='1005'">
        <a routerLink="/inspector/alcdashboardleo"><i style="color: #89C7F3" class="fa fa-dashboard fa-2x"></i><span
            class="nav-text">Dashboard of Schemes leo </span></a>
      </li>
        <li class="has-subnav mt-2"
          *ngIf="userinfo.ELRole !='ALLC' && userinfo.role !='1005' && userinfo.role !='VLE' && userinfo.role != '1023' && userinfo.role != '1022' && userinfo.role != '1041' && userinfo.role != '1011' && userinfo.role != '1010' && userinfo.role != '1016' && userinfo.role != '1012' && userinfo.role != '1006' && userinfo.ELRole !='ALLC' && userinfo.ELRole !='AUDT' && userinfo.role != '1040' || userinfo.ELRole =='BCAO'  && userinfo.ELRole!='PSLD'  &&  userinfo.role!='sewakendra' && userinfo.role!=1003 && userinfo.role !='VLE'  && userinfo.role!='sewakendra' ">
          <a routerLink="/inspector/schemes"><i style="color: #89C7F3" class="fa fa-dashboard fa-2x"></i><span
              class="nav-text">Dashboard of Schemes </span></a>
        </li>
        <li class="has-subnav mt-2"
          *ngIf="userinfo.role !='VLE' && userinfo.role == '1011' && userinfo.ELRole !='ALLC' && userinfo.role !='1005' && userinfo.role == '1010' && userinfo.role == '1016' && userinfo.role == '1012' && userinfo.role == '1006'  ">
          <a routerLink="/inspector/head-office-schemes"><i style="color: #89C7F3"
              class="fa fa-dashboard fa-2x"></i><span class="nav-text">Dashboard of Schemes </span></a>
        </li>

        <li class="has-subnav mt-2"
          *ngIf="userinfo.role !='VLE' && userinfo.role == '1011' || userinfo.role == '1010' || userinfo.role == '1016' || userinfo.role == '1012' || userinfo.role == '1006'  ">
          <a routerLink="/inspector/PaymentFreezComponent"><i style="color: #89C7F3"
              class="fa fa-dashboard fa-2x"></i><span class="nav-text">Dashboard of CSC payment </span></a>
        </li>


        <li class="has-subnav mt-2" *ngIf="userinfo.ELRole =='LBIN'  || userinfo.role=='1004' || userinfo.role=='1001'">
          <a routerLink="/inspector/aco-schemes"><i style="color: #89C7F3" class="fa fa-dashboard fa-2x"></i><span
              class="nav-text">Scheme Dashboard of Aco</span></a>
        </li>
        <li class="has-subnav mt-2" *ngIf="userinfo.role==1018">
          <a routerLink="/sewakendra/dashboard"><i style="color: #89C7F3" class="fa fa-dashboard fa-2x"></i><span
              class="nav-text">Sewa Dashboard</span></a>
        </li>

        <li class="has-subnav mt-2" *ngIf="userinfo.ELRole =='LBIN'  || userinfo.role=='1004' || userinfo.role=='1001'">
          <a routerLink="/inspector/aco-files"><i style="color: #89C7F3" class="fa fa-dashboard fa-2x"></i><span
              class="nav-text">Dashboard Of Aco</span></a>
        </li>


        <li class="has-subnav mt-2"
          *ngIf="userinfo.ELRole =='LBIN'  || userinfo.role=='1004' || userinfo.role=='1001' ">
          <a routerLink="/worker/withdraw-application"><i style="color: #89C7F3" class="fa fa-dashboard fa-2x"></i><span
              class="nav-text">Withdraw application</span></a>
        </li>
        <!-- <li class="has-subnav mt-2" *ngIf="userinfo.role=='1004' || userinfo.ELRole =='LBIN'">
          <a routerLink="/inspector/alcprocesslevel"><i style="color: #ff731e"  class="fa fa-dashboard fa-2x"></i><span class="nav-text">Dashboard of ALC  </span></a>
        </li> -->

        <li class="has-subnav mt-2" *ngIf="userinfo.role=='1005' || userinfo.ELRole =='ALLC'">
          <a routerLink="/inspector/alcschemesprocess"><i style="color: #ff731e" class="fa fa-dashboard fa-2x"></i><span
              class="nav-text">Dashboard of Schemes-in-Process </span></a>
        </li>
        <li class="has-subnav mt-2" *ngIf="userinfo.role=='1005' || userinfo.ELRole =='ALLC'">
          <a routerLink="/inspector/alcschemeswaitingapprovel"><i style="color: #ff731e"
              class="fa fa-dashboard fa-2x"></i><span class="nav-text">Dashboard of Schemes Waiting Approvel </span></a>
        </li>
        <li class="has-subnav mt-2" *ngIf="userinfo.role=='1016'">
          <a routerLink="/inspector/dptschemesprocess"><i style="color: #ff731e" class="fa fa-dashboard fa-2x"></i><span
              class="nav-text">Dashboard of Cycle Schemes-in-Process </span></a>
        </li>
        <li class="has-subnav mt-2" *ngIf="userinfo.role=='1016'">
          <a routerLink="/inspector/dptschemeswaitingapprovel"><i style="color: #ff731e"
              class="fa fa-dashboard fa-2x"></i><span class="nav-text">Dashboard of Cycle Schemes Waiting Approvel
            </span></a>
        </li>
        <li class="has-subnav mt-2" *ngIf="userinfo.role=='1005' || userinfo.ELRole =='ALLC'">
          <a routerLink="/inspector/alcobjectionbyhead"><i style="color: #ff731e"
              class="fa fa-dashboard fa-2x"></i><span class="nav-text">Dashboard of Objection By Head Office </span></a>
        </li>
        <li class="has-subnav mt-2" *ngIf="userinfo.ELRole =='LBIN' || userinfo.role == '1004' ">
          <a routerLink="/inspector/leoobjectionbyalc"><i style="color: #ff731e" class="fa fa-dashboard fa-2x"></i><span
              class="nav-text">Objection By ALC(Head Office) </span></a>
        </li>
        <li class="has-subnav mt-2" *ngIf="userinfo.ELRole =='ALLC' || userinfo.role == '1005' ">
          <a routerLink="/inspector/objectionresolvedbyleo"><i style="color: #ff731e"
              class="fa fa-dashboard fa-2x"></i><span class="nav-text">Objection Resolved by Leo </span></a>
        </li>
        <!-- <li class="has-subnav mt-2" *ngIf="userinfo.ELRole =='BWDH'  || userinfo.role==1009 ">
            <a routerLink="/inspector/dhl-schemes"><i style="color: #ff731e"  class="fa fa-dashboard fa-2x"></i><span class="nav-text">dhlSchemes Dashboard </span></a>
          </li> -->
        <li class="has-subnav mt-2" *ngIf="userinfo.role==1004">
          <a routerLink="/inspector/status-track-all-level"><i style="color: #ff731e"
              class="fa fa-dashboard fa-2x"></i><span class="nav-text">Dashboard of ALC Schemes</span></a>
        </li>
        <li class="has-subnav mt-2" *ngIf="userinfo.ELRole !='BCAO'  || userinfo.ELRole!='PSLD'  ||  userinfo.role!='sewakendra' && userinfo.role!=1003 && userinfo.role !='VLE'  && userinfo.role!='sewakendra'">
          <a routerLink="/inspector/status-track"><i style="color: #ff731e" class="fa fa-dashboard fa-2x"></i><span
              class="nav-text">Schemes status track </span></a>
        </li>
        <li class="has-subnav mt-2" *ngIf="userinfo.role==1004">
          <a routerLink="/inspector/head-status-track"><i style="color: #ff731e" class="fa fa-dashboard fa-2x"></i><span
              class="nav-text">Schemes status track(HQ) </span></a>
        </li>









        <!-- <li class="has-subnav mt-2" *ngIf=" userinfo.ELRole !='BCAO'  || userinfo.ELRole!='PSLD'  ||  userinfo.role!='sewakendra' && userinfo.role!=1003 && userinfo.role !='VLE'  && userinfo.role!='sewakendra' ">
            <a routerLink="/inspector/reverse-payment"><i style="color: #ff731e"  class="fa fa-dashboard fa-2x"></i><span class="nav-text">Reverse Payment </span></a>
          </li>
         <li class="has-subnav mt-2" *ngIf="userinfo.role!='sewakendra' && userinfo.role!=1003 && userinfo.role !='VLE' && userinfo.role!='sewakendra' ">
            <a routerLink="/cess/cess-payment-dashboard"><i style="color: #15e9d7"  class="fa fa-dashboard fa-2x"></i><span class="nav-text">Cess Dashboard </span></a>
        </li> -->
        <li class="has-subnav mt-2" *ngIf="userinfo.role ==1001 || userinfo.role=='sewakendra'">
          <a routerLink="/worker/renew"><i class="fa fa-retweet text-success" aria-hidden="true"></i><span
              class="nav-text">Application of Renewal worker</span></a>
        </li>

        <li class="has-subnav mt-2" *ngIf="userinfo.role=='1001' || userinfo.role=='1004' ">

          <a routerLink="/inspector/update-old-document"><i class="fa fa-retweet text-success"
              aria-hidden="true"></i><span class="nav-text">Upload Old Document</span></a>
        </li>
        <li class="has-subnav mt-2" *ngIf="userinfo.role=='1001' ">
          <a routerLink="/worker/update-worker-info"><i class="fa fa-retweet text-success" aria-hidden="true"></i><span
              class="nav-text">Update Worker Info</span></a>
        </li>
        <li class="has-subnav mt-2" *ngIf="userinfo.role=='1060'">
          <a routerLink="/inspector/update-account"><i class="fa fa-retweet text-success" aria-hidden="true"></i><span
              class="nav-text">Worker Update AC/IFSC </span></a>
        </li>
        <li class="has-subnav mt-2" *ngIf="userinfo.role ==1006 || userinfo.role ==1001" style="display: block">
          <a routerLink="/worker/bank-account"><i class="fa fa-retweet text-success" aria-hidden="true"></i><span
              class="nav-text">Worker Bank Detail </span></a>
        </li>
        <li class="has-subnav mt-2" *ngIf="userinfo.role ==1006 || userinfo.ELRole =='LBCR'" style="display: block">
          <a routerLink="/worker/approved-account-by-lc"><i class="fa fa-retweet text-success"
              aria-hidden="true"></i><span class="nav-text">Worker Account Approved</span></a>
        </li>
        <li class="has-subnav mt-2" *ngIf="userinfo.role ==1060" style="display: block">
          <a routerLink="/worker/pending-account-lc"><i class="fa fa-retweet text-success" aria-hidden="true"></i><span
              class="nav-text">Worker Account Pending </span></a>
        </li>
        <li class="has-subnav mt-2"
          *ngIf="userinfo.ELRole =='BCAO'  || userinfo.role=='1017' || userinfo.ELRole =='LBIN'  || userinfo.role=='1004' || userinfo.role=='1001'">
          <a routerLink="/worker/details"><i class="fa fa-exclamation-triangle text-warning"
              aria-hidden="true"></i><span class="nav-text">Search of Objection App</span></a>
        </li>
        <li class="has-subnav mt-2" *ngIf="userinfo.role ==1001">
          <a routerLink="/worker/worker-fees"><i class="fa fa-exclamation-triangle text-warning"
              aria-hidden="true"></i><span class="nav-text">Worker-fees</span></a>
        </li>
        <li class="has-subnav mt-2" *ngIf="userinfo.role ==1001">
          <a routerLink="/worker/worker-old-copy-fees"><i class="fa fa-exclamation-triangle text-warning"
              aria-hidden="true"></i><span class="nav-text">Worker-Old-Copy-fees</span></a>
        </li>


        <li class="has-subnav mt-2"
          *ngIf="userinfo.ELRole =='BCAO'  || userinfo.role=='1017' || userinfo.ELRole =='LBIN'  || userinfo.role=='1004' || userinfo.role=='1001' || userinfo.role=='1005' || userinfo.ELRole =='ALLC'">
          <a routerLink="/worker/schemedetails"><i class="fa fa-exclamation-circle text-warning"
              aria-hidden="true"></i><span class="nav-text">Search of objection Schemes</span></a>
        </li>

        <li class="has-subnav mt-2"
          *ngIf="userinfo.role !='VLE' && userinfo.ELRole !='AUDT' || userinfo.role != '1040' || userinfo.role != '1060' || userinfo.role!='sewakendra' ">
          <a routerLink="/worker/search-worker"><i class="fa fa-exclamation-circle text-warning"
              aria-hidden="true"></i><span class="nav-text">Search of Worker Information</span></a>
        </li>
        <li class="has-subnav mt-2" *ngIf="userinfo.role ==1001">
          <a routerLink="/worker/dlink"><i class="fa fa-exclamation-circle text-warning" aria-hidden="true"></i><span
              class="nav-text">D-link</span>
            </a>
        </li>
        <!--  *ngIf="userinfo.role !=1004 && userinfo.role !=1005 && userinfo.role !=1001  && userinfo.ELRole !='BCAO'   " -->
        <!-- <li class="has-subnav mt-2" *ngIf="userinfo.ELRole !='AUDT' && userinfo.role != '1040' && userinfo.role !=1006 && userinfo.role !='LBCR'   ">
          <a routerLink="/worker/search-file-status" ><i class="fa fa-exclamation-circle text-warning" aria-hidden="true"></i><span class="nav-text">Check Status</span></a>
        </li> -->
        <!--  -->


        <li class="has-subnav mt-2 " *ngIf="userinfo.role =='1001'">

          <a routerLink="/payment/makepayment"><i class="fa fa-credit-card fa-2x text-info"></i><span
              class="nav-text">Process Payment</span></a>
        </li>
        <li class="has-subnav mt-2" *ngIf="userinfo.role =='VLE' ">
          <a routerLink="/payment/pending"><i class="fa fa-credit-card fa-2x text-info"></i><span
              class="nav-text">Pending Payments</span></a>
        </li>
        <!-- <li class="has-subnav mt-2"  *ngIf="userinfo.role ==1001 || userinfo.role ==1004">
          <a routerLink="/reports/update-account"><i class="fa fa-credit-card fa-2x text-info"></i><span class="nav-text">Report Update Accounts</span></a>
        </li> -->
       
        <!-- <li class="has-subnav mt-2"  *ngIf="userinfo.role ==1001 || userinfo.role ==1004">
          <a routerLink="/reports/live-worker-report"><i class="fa fa-credit-card fa-2x text-info"></i><span class="nav-text">Report Live Workers</span></a>
        </li> -->
        <li class="has-subnav mt-2" *ngIf="userinfo.role ==1001 || userinfo.ELRole =='AUDT' || userinfo.role == '1040'">
          <a routerLink="/worker/welfare-schemes"><i class="fa fa-credit-card fa-2x text-info"></i><span
              class="nav-text">Welfare schemes</span></a>
        </li>
        <li class="has-subnav mt-2" *ngIf="userinfo.role == 1001 && userinfo.ELRole!='PSLD'">
          <a routerLink="/admin/view-static-content" [queryParams]="{type: '1'}"><i class="fa fa-address-card text-info"
              aria-hidden="true"></i><span class="nav-text">Static Content</span></a>
        </li>
        <li class="has-subnav mt-2" *ngIf="userinfo.role == 1001 && userinfo.ELRole!='PSLD'">
          <a routerLink="/admin/view-static-services" [queryParams]="{type: '1'}"><i class="fa fa-address-card text-info"
              aria-hidden="true"></i><span class="nav-text">Static Services Data</span></a>
        </li>
        <li class="has-subnav mt-2" *ngIf="userinfo.role!='VLE'">
          <a routerLink="/reports/cycle-schemes-dashboard"><i class="fa fa-credit-card fa-2x text-info"></i><span
              class="nav-text"> Cycle Dashboard by district</span></a>
        </li>
        <li class="has-subnav mt-2" >
          <a routerLink="/schemes/index"><i class="fa fa-credit-card fa-2x text-info"></i><span
              class="nav-text">scheme index</span></a>
        </li>
        <li class="has-subnav mt-2"
        *ngIf="userinfo.role !='VLE' && userinfo.role != '1022' && userinfo.role != '1023' && userinfo.ELRole !='AUDT' && userinfo.role != '1040' && userinfo.role != '1041' && userinfo.role != '1060'">
        <a routerLink="/reports/worker-dashboard"><i class="fa fa-credit-card fa-2x text-info"></i><span
            class="nav-text">Report of registered worker</span></a>
      </li>
      <li class="has-subnav mt-2"
        *ngIf="userinfo.role ==1001 || userinfo.role ==1016">
        <a routerLink="/reports/schemes-dashboard"><i class="fa fa-credit-card fa-2x text-info"></i><span
            class="nav-text">Report of welfare schemes </span></a>
      </li>
        <li class="has-subnav mt-2"
          *ngIf="userinfo.role ==1009 || userinfo.role ==1010 || userinfo.role ==1008 || userinfo.role ==1001  ">
          <a routerLink="/reports/e-sewa"><i class="fa fa-credit-card fa-2x text-info"></i><span class="nav-text">Report
              E-Sewa</span></a>
        </li>
        <!-- <li class="has-subnav mt-2"
          *ngIf="userinfo.role ==1009 || userinfo.role ==1010 || userinfo.role ==1008 || userinfo.role ==1001   ">
          <a routerLink="/reports/e-sewa-pendency"><i class="fa fa-credit-card fa-2x text-info"></i><span
              class="nav-text">Report E-Sewa-Pendency</span></a>
        </li> -->
        <!-- <li class="has-subnav mt-2"
          *ngIf="userinfo.role ==1009 || userinfo.role ==1010 || userinfo.role ==1008 || userinfo.role ==1001   ">
          <a routerLink="/reports/e-sewa-operator-pendency"><i class="fa fa-credit-card fa-2x text-info"></i><span
              class="nav-text">E-Operator-Pendency</span></a>
        </li> -->
        <li class="has-subnav mt-2"
          *ngIf="userinfo.role ==1009 || userinfo.role ==1010 || userinfo.role ==1008 || userinfo.role ==1001   ">
          <a routerLink="/reports/csc"><i class="fa fa-credit-card fa-2x text-info"></i><span class="nav-text">Report
              CSC</span></a>
        </li>
        <li class="has-subnav mt-2">
          <a routerLink="/reports/complete"><i class="fa fa-credit-card fa-2x text-info"></i><span
              class="nav-text">Report Complete</span></a>
        </li>
        <li class="has-subnav mt-2" *ngIf="userinfo.role ==1009  && userinfo.ELRole!='PSLD'  ">
          <a routerLink="/payment/refund"><i class="fa fa-credit-card fa-2x text-info"></i><span class="nav-text">Refund
              CSC Payment</span></a>
        </li>

      </div>
      
      <li class="has-subnav mt-2"
        *ngIf="userinfo.role !='VLE' && userinfo.role != '1022' && userinfo.role != '1023' && userinfo.role !='1006' && userinfo.ELRole !='LBCR' && userinfo.ELRole !='AUDT' && userinfo.role != '1040' && userinfo.role != '1041' || userinfo.role == 1001  || userinfo.role == 1005  ">
        <a routerLink="/reports/mis-old-schemes"><i class="fa fa-credit-card fa-2x text-info"></i><span
            class="nav-text">Report Old Schemes</span></a>
      </li>
      <li class="has-subnav mt-2" *ngIf="userinfo.role == 1001 || userinfo.role == 1005 || userinfo.role == 'BADM'  ">
        <a routerLink="/reports/month-report"><i class="fa fa-credit-card fa-2x text-info"></i><span
            class="nav-text">Report ALC/LCO Schemes</span></a>
      </li>
      <li class="has-subnav mt-2"
        *ngIf="userinfo.role !='VLE' && userinfo.role !='1022' && userinfo.role !='1023' && userinfo.role !='1006' && userinfo.ELRole !='LBCR' && userinfo.ELRole !='AUDT' && userinfo.role != '1040' || userinfo.role == 1001   ">
        <a routerLink="/reports/mis-approved"><i class="fa fa-credit-card fa-2x text-info"></i><span
            class="nav-text">Report Approved</span></a>
      </li>
     
      <li class="has-subnav mt-2" *ngIf="userinfo.role!='VLE'">
        <a routerLink="/reports/cycle-schemes"><i class="fa fa-credit-card fa-2x text-info"></i><span
            class="nav-text">Report Cycle Dashboard(ALC level)</span></a>
      </li>
      

      <!-- <li class="has-subnav mt-2"  *ngIf="userinfo.ELRole !='AUDT' && userinfo.role != '1040' && userinfo.role !='1006' && userinfo.ELRole !='LBCR' || userinfo.role == 1001 ||  userinfo.role == 1005"  >
          <a routerLink="/reports/pendency"><i class="fa fa-credit-card fa-2x text-info"></i><span class="nav-text">Report Pendency</span></a>
        </li> -->
      <!-- <li class="has-subnav mt-2"    >
          <a routerLink="/reports/registration-report"><i class="fa fa-credit-card fa-2x text-info"></i><span class="nav-text">Registration Report</span></a>
        </li>
        <li class="has-subnav mt-2"    >
          <a routerLink="/reports/schemes-report"><i class="fa fa-credit-card fa-2x text-info"></i><span class="nav-text">Schemes Report</span></a>
        </li>
        <li class="has-subnav mt-2"    >
          <a routerLink="/reports/live-worker"><i class="fa fa-credit-card fa-2x text-info"></i><span class="nav-text">Live Worker Report</span></a>
        </li> -->


      <!-- <li class="has-subnav mt-2"  *ngIf="userinfo.role !='1006' && userinfo.ELRole !='LBCR' || userinfo.role == 1001 ||  userinfo.role == 1009"  >
          <a routerLink="/inspector/batch-dhl"><i class="fa fa-credit-card fa-2x text-info"></i><span class="nav-text">DHL upload Excel</span></a>
        </li>
        <li class="has-subnav mt-2"  *ngIf="userinfo.role !='1006' && userinfo.ELRole !='LBCR' || userinfo.role == 1001 ||  userinfo.role == 1017 ||  userinfo.role == 1004"  >
          <a routerLink="/inspector/batch-excel"><i class="fa fa-credit-card fa-2x text-info"></i><span class="nav-text">ALC upload Excel</span></a>
        </li>
        <li class="has-subnav mt-2"  *ngIf="userinfo.role !='1006' && userinfo.ELRole !='LBCR' || userinfo.role == 1001 ||  userinfo.role == 1017 ||  userinfo.role == 1004"  >
          <a routerLink="/inspector/dhl-excel"><i class="fa fa-credit-card fa-2x text-info"></i><span class="nav-text">DHL Excel</span></a>
        </li> -->
      <!-- <li class="has-subnav mt-2"  *ngIf="userinfo.role=='1001'"  >
          <a routerLink="/inspector/viewoldportal"><i class="fa fa-credit-card fa-2x text-info"></i><span class="nav-text">viewoldportal</span></a>
        </li>
        <li class="has-subnav mt-2"  *ngIf="userinfo.role == 1001 "  >
          <a routerLink="/inspector/oldportal-payment"><i class="fa fa-credit-card fa-2x text-info"></i><span class="nav-text">oldportal-payment</span></a>
        </li>
        <li class="has-subnav mt-2"  *ngIf="userinfo.role == 1001"  >
          <a routerLink="/inspector/SbiMisPaymentExcel"><i class="fa fa-credit-card fa-2x text-info"></i><span class="nav-text">SbiMis Payment Excel</span></a>
        </li>
        <li class="has-subnav mt-2"  *ngIf="userinfo.role !='1006' && userinfo.ELRole !='LBCR' && userinfo.ELRole !='AUDT' && userinfo.role != '1040' || userinfo.role == 1001   " >
          <a routerLink="/reports/worker-schemes"><i class="fa fa-credit-card fa-2x text-info"></i><span class="nav-text">Report worker/schemes</span></a>
        </li>
        <li class="has-subnav mt-2"  *ngIf="userinfo.role !='1006' && userinfo.ELRole !='LBCR' && userinfo.ELRole !='AUDT' && userinfo.role != '1040' || userinfo.role == 1001   " >
          <a routerLink="/reports/mis-approved"><i class="fa fa-credit-card fa-2x text-info"></i><span class="nav-text">Report Approved</span></a>
        </li>
        <li class="has-subnav mt-2"  *ngIf="userinfo.ELRole !='AUDT' && userinfo.role != '1040' || userinfo.role == 1001 ||  userinfo.role == 1005 " >
          <a routerLink="/reports/allcircle"><i class="fa fa-credit-card fa-2x text-info"></i><span class="nav-text">Report All Approved</span></a>
        </li>
        <li class="has-subnav mt-2"  *ngIf="userinfo.role !='1006' && userinfo.ELRole !='LBCR' && userinfo.ELRole !='AUDT' && userinfo.role != '1040' || userinfo.role == 1001  || userinfo.role == 1005  " >
          <a routerLink="/reports/mis-old-schemes"><i class="fa fa-credit-card fa-2x text-info"></i><span class="nav-text">Report Old Schemes</span></a>
        </li>
        <li class="has-subnav mt-2"  *ngIf="userinfo.role !='1006' && userinfo.ELRole !='LBCR' && userinfo.ELRole !='AUDT' && userinfo.role != '1040' || userinfo.role == 1001 || userinfo.role == 1005  "  >
          <a routerLink="/reports/mis-new-schemes"><i class="fa fa-credit-card fa-2x text-info"></i><span class="nav-text">Report New Schemes</span></a>
        </li>
        <li class="has-subnav mt-2"  *ngIf="userinfo.role !='1006' && userinfo.ELRole !='LBCR' && userinfo.ELRole !='AUDT' && userinfo.role != '1040' || userinfo.role == 1001 || userinfo.role == 1005  "  >

          <a routerLink="/reports/covid-report"><i class="fa fa-credit-card fa-2x text-info"></i><span class="nav-text">Covid Report  </span></a>
        </li> -->

      <!-- <li class="has-subnav mt-2"  >
            <a routerLink="/reports/month-report-detail"><i class="fa fa-credit-card fa-2x text-info"></i><span class="nav-text">Report MWRR</span></a>
          </li>  -->



    </ul>
    <ul *ngIf="userinfo.role == 1001 && (userinfo.ELRole !='AUDT' || userinfo.role != '1040')">
      <li class="has-subnav mt-2" *ngIf="userinfo.role == 1001  && userinfo.ELRole !='PSLD'">
        <a routerLink="/admin/officer-detail"><i class="fa fa-credit-card fa-2x text-info"></i><span
            class="nav-text">officer Detail</span></a>
      </li>
      <!--*ngIf=" userinfo.role == 'BADM'  "-->
      <li class="has-subnav mt-2" *ngIf="userinfo.role == 1001  && userinfo.ELRole !='PSLD'">
        <a routerLink="/admin/users-detail"><i class="fa fa-credit-card fa-2x text-info"></i><span
            class="nav-text">Users Detail</span></a>
      </li>

      <li class="has-subnav mt-2" *ngIf="userinfo.role == 1001  && userinfo.ELRole !='PSLD'">
        <a routerLink="/admin/users-assign"><i class="fa fa-credit-card fa-2x text-info"></i><span
            class="nav-text">Users Assign</span></a>
      </li>
      <!-- <li class="has-subnav mt-2" *ngIf="userinfo.role == 1001  && userinfo.ELRole !='PSLD'">
        <a routerLink="/admin/receipt"><i class="fa fa-credit-card fa-2x text-info"></i><span
            class="nav-text">receipt Detail</span></a>
      </li> -->
    
      <!-- <li class="has-subnav mt-2"    >
        <a routerLink="/reports/main-registration"><i class="fa fa-credit-card fa-2x text-info"></i><span class="nav-text">Workers MIS</span></a>
      </li>
      <li class="has-subnav mt-2"    >
        <a routerLink="/reports/scheme-report"><i class="fa fa-credit-card fa-2x text-info"></i><span class="nav-text">Beneficiary Schemes MIS</span></a>
      </li> -->

      <!-- <li class="has-subnav mt-2"  *ngIf="userinfo.role == 1001  && userinfo.ELRole !='PSLD'"  >
        <a href="https://bocw.punjab.gov.in/bapi/get/reverse/files/list" target="_blank"><i class="fa fa-credit-card fa-2x text-info"></i><span class="nav-text">Bank Reverse</span></a>
      </li>
      <li class="has-subnav mt-2"  *ngIf="userinfo.role ==1001 || userinfo.ELRole =='PSLD'">
        <a href="https://bocw.punjab.gov.in/bapi/sewakendra-report" target="_blank" ><i class="fa fa-credit-card fa-2x text-info"></i><span class="nav-text">Sewa kendra report</span></a>
      </li> -->
      <li class="has-subnav mt-2">

        <a routerLink="/inspector/off-line-payment-detail"><i class="fa fa-credit-card fa-2x text-info"></i><span
            class="nav-text">OffLine</span></a>
      </li>
      <li class="has-subnav mt-2" *ngIf="userinfo.role == 1001  && userinfo.ELRole !='PSLD'">
        <a href="https://bocw.punjab.gov.in/bapi/get/reverse/files/list" target="_blank"><i
            class="fa fa-credit-card fa-2x text-info"></i><span class="nav-text">Bank Reverse</span></a>
      </li>

      

      <!-- <li class="has-subnav mt-2"    >
        <a routerLink="/reports/testing-report"><i class="fa fa-credit-card fa-2x text-info"></i><span class="nav-text">Testing Report</span></a>
      </li> -->
      <!-- <li class="has-subnav mt-2"    >
        <a routerLink="/reports/scheme-report"><i class="fa fa-credit-card fa-2x text-info"></i><span class="nav-text">Scheme Report</span></a>
      </li> -->


    </ul>
    <ul *ngIf="userinfo.ELRole =='AUDT' || userinfo.role == '1040'">
      <li class="has-subnav mt-2">
        <a routerLink="/worker/search-worker"><i class="fa fa-exclamation-circle text-warning"
            aria-hidden="true"></i><span class="nav-text">Search Worker</span></a>
      </li>
      <li class="has-subnav mt-2" *ngIf="userinfo.role ==1001 || userinfo.ELRole =='AUDT' || userinfo.role == '1040'">
        <a routerLink="/worker/welfare-schemes"><i class="fa fa-credit-card fa-2x text-info"></i><span
            class="nav-text">Welfare schemes</span></a>
      </li>
    </ul>

    <ul>
      <li class="has-subnav mt-2"    >
        <a routerLink="/reports/Reports"><i class="fa fa-credit-card fa-2x text-info"></i><span class="nav-text">scheme Report</span></a>
      </li>
      <li>
        <a (click)="logout()"><i class="fa fa-power-off fa-2x text-danger"></i><span class="nav-text">Logout</span></a>
      </li>
    </ul>